import * as React from 'react';
import ApplicationStateButtons, { Props } from './application_state_buttons';
import { shallow, ShallowWrapper } from 'enzyme';
import applicationDummy from '__fixtures__/application_dummy';

const createTestProps = moreProps => {
  return {
    delivered: true,
    moveToStep: jest.fn(),
    rejectApplication: jest.fn(),
    small: true,
    waitingReview: true,
    application: applicationDummy,
    ...moreProps,
  };
};

let props: Props;
let wrapped: ShallowWrapper;

describe('Application State Buttons component', () => {
  beforeEach(() => {
    props = createTestProps({});
    wrapped = shallow(<ApplicationStateButtons {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

test.todo('add more tests');
